import React, { Component, type ReactNode } from "react";
import { connect } from "react-redux";
import { type Dispatch as ReduxDispatch, bindActionCreators } from "redux";
import { RemoveMessage } from "src/app/actions/AppActionCreator";
import type { IAppReducerAction } from "src/app/reducers/AppReducer";
import Messages, {
  type Message,
} from "src/shared/messages/components/Messages";

export interface IHeaderMessages {}

export interface IHeaderMessagesWithRedux extends IHeaderMessages {
  messages: Message[];
  RemoveMessage: (message: Message) => IAppReducerAction;
}

class HeaderMessages extends Component<IHeaderMessagesWithRedux> {
  public render(): ReactNode {
    const { RemoveMessage } = this.props;
    return (
      <Messages messages={this.props.messages} onHideMessage={RemoveMessage} />
    );
  }
}

// Bind with Redux.
export default connect(
  (state) => {
    return {
      messages: state.app.messages,
    };
  },
  (dispatch: ReduxDispatch) => {
    return bindActionCreators(
      {
        RemoveMessage,
      },
      dispatch,
    );
  },
)(HeaderMessages);
